<template>
  <div class="content">
    <p>目前医疗机构供氧基本采取集中供氧、按照氧源的不同可分为3种方式，即：由瓶氧经汇流排减压集中供氧，由液氧贮槽经液氧汽化、减压、稳压后集中供氧，以及由变压吸附制氧设备（PSA）生产医用氧气后连续供氧。PSA制氧供氧技术在国外已经有几十年的使用历史。国内这一技术的应用始于20世纪80年代末，9年代初这一技术得到了迅速的发展。</p>
    <p>医用分子筛制氧设备按其预期用途，可分为两大类：一种是由制氧机、空压机、冷干机、氧气储罐、控制系统等多部分组成，主要配套用于医疗单位中心供氧系统，提供医用氧气源，或是与高压氧舱配套为高压氧舱提供氧气源的大型医用分子筛制氧设备；另一种是用于分子筛吸附装置、过滤装置、流量计、湿化瓶等部分组成，主要供医疗单位或家庭供氧保健或辅助治疗的家用小型分子筛制氧机。</p>
    <p>医疗机构通过分子筛制氧设备制取的氧气作为集中供氧的氧源，其氧气终端（氧气输出口）通过医院的各个科室，如门诊急救室、抢救室、普通病房、病区抢救室、ICU病房用氧、高压氧舱用氧和普通病房用氧，</p>
    <p>麻醉机、呼吸机以及ICU病房用氧对供氧的时间和压力要求相对较为严格，其氧气含量可调整范围在21%-90%之间。另外，医药行业标准YY0042-2007《高频喷射呼吸机》中规定了呼吸机的最高氧浓度达85%即满足标准的相关要求。</p>
    <p>高压氧舱的用氧特点是瞬时用氧量大、氧气压力高。按加压介质来看，可分为：（1）空气加压舱：一般为4人以上，多者可达数十人的多人治疗舱，以及手术舱、过度舱等。空气加压舱内氧气浓度限制为25%以下，（2）氧气加压舱：一般为双人或单人的治疗用舱，婴儿氧舱亦属于此列。氧气加压舱治疗时舱内氧浓度一般均高于80%。</p>
    <p>目前各医疗机构高压氧舱用氧源既有液态瓶装氧，也有利用分子筛制氧设备提供氧源的情况。对于不同的供氧方式氧气在高压氧舱的使用上，临床并没有明确的限制。</p>
    <p>目前利用医用分子筛制氧设备制取临床用氧现象较为普遍，且反映对利用分子筛制氧原理制取的氧气与液态瓶装氧气在临床使用中并没有实质性的区别。事实上，美国、加拿大以及英国的医疗机构、科研机构研究表明，利用分子筛制氧设备制取的医用氧气与传统的医用液态氧相比较，临床使用上的要求并无不同，对于患者治疗具有同等的质量</p>
  </div>
</template>

<script>
export default {
  name: 'TabOxygenConcentratorCurrentStatus'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  p{
    line-height: 36px;
    text-indent:40px;
  }
}
</style>
